export const contingentLocationPinIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 13 18"><g opacity=".5" stroke="#9CBAC7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 7c0 4.5-5.5 9.5-5.5 9.5S1 11.5 1 7a5.5 5.5 0 1111 0v0z"/><path d="M6.5 9.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"/></g></svg>`,
  name: 'location-pin',
};
